import { useMemo } from "react";
import type {
	ClientPropertyItemResponseDTO,
	PortfolioListItemResponseDTO,
	PortfolioListReportingSummaryResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import {
	PORTFOLIO_SORT,
	type PortfolioSortKey,
} from "web_myplann/Portfolio/Components/Redesign/Filter/portfolioSortKey";
import { bucketPortfolioItems } from "web_myplann/Portfolio/Helpers/bucketPortfolioItems";
import { sortPortfolioCategoryItems } from "web_myplann/Portfolio/Helpers/portfolioCategorySort";
import {
	PORTFOLIO_CATEGORY_ORDER,
	type PortfolioCategory,
	type PortfolioCategoryId,
} from "web_myplann/Portfolio/Types/portfolioCategory";

type Options = {
	categories?: Set<PortfolioCategoryId>;
	sort?: PortfolioSortKey;
	sortDesc?: boolean;
	summaryData?: PortfolioListReportingSummaryResponseDTO[];
};

export const usePortfolioCategories = (
	portfolioData: PortfolioListItemResponseDTO[],
	propertyData: ClientPropertyItemResponseDTO[],
	{
		categories,
		sort = PORTFOLIO_SORT.name,
		sortDesc = false,
		summaryData,
	}: Options = {},
): PortfolioCategory[] => {
	const { t } = useResource();

	return useMemo(() => {
		const buckets = bucketPortfolioItems(portfolioData, propertyData);

		return PORTFOLIO_CATEGORY_ORDER.filter(
			(id) => !categories || categories.has(id),
		)
			.map((id) => ({
				id,
				items: sortPortfolioCategoryItems(
					buckets[id],
					sort,
					sortDesc,
					summaryData,
					t,
				),
			}))
			.filter((category) => category.items.length > 0);
	}, [portfolioData, propertyData, categories, sort, sortDesc, summaryData, t]);
};
